import { Box, Grid } from '@mui/material'
import { type EventDTO, VerticalCard } from '~entities/index'

export const TwoCardsGroup = ({ events }: { events: EventDTO[] }) => {
	return (
		<Box minWidth={'320px'} maxWidth={'320px'}>
			<Grid container spacing='32px'>
				<Grid size={12} display='flex'>
					<VerticalCard
						info={events[0]}
						isSmall
					/>
				</Grid>
				<Grid size={12} display='flex'>
					<VerticalCard
						info={events[1]}
						isSmall
					/>
				</Grid>
			</Grid>
		</Box>
	)
}
